import { AbstractModel } from './Abstract.model';

export class Witness extends AbstractModel {
  /** Copy constructor */
  constructor(fromObj?: object) {
    super();
    Object.assign(this, fromObj);
  }

  lastname?: string;
  firstname?: string;
  email?: string;
  phone?: string;
  address?: string;
}
